import script from "./SemesterManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SemesterManagement.vue?vue&type=script&setup=true&lang=js"

import "./SemesterManagement.vue?vue&type=style&index=0&id=7f348f46&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f348f46"]])

export default __exports__